"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const _1 = require(".");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const arrayToString = (descriptions) => {
        return `${descriptions.join().replace(/,/g, '')}`;
    };
    //? 기본
    const basicProps = {
        descriptions: [
            `■ ${t('문의 메일')}:\n\n`,
            `■ ${t('공지하는 곳')}:\n\n`,
            `■ ${t('교환 기준(불량&누락)')}:\n\n`,
            `■ ${t('환불 기준')}:`,
        ],
        message: t('기본 안내가 추가되었어요'),
        name: t('기본'),
    };
    //? 주문제작
    const customProps = {
        descriptions: [
            `■ ${t('문의 메일')}:\n\n`,
            `■ ${t('공지하는 곳')}:\n\n`,
            `■ ${t('교환 기준(불량&누락)')}:\n\n`,
            `■ ${t('환불 기준')}:\n\n`,
            `■ ${t('주문 제작: 본 작품은 주문제작 작품으로 청약철회의 예외사유에 해당하여 이후 주문취소시 전액 환불이 어려울 수 있습니다. 주문 제작 특성상 배송까지 최소 1개월에서 반년 이상 오랜 시간이 걸릴 수 있습니다. 신중한 구매를 부탁드립니다. 주문 제작이란 1:1로 소비자 개개인에 대한 맞춤 제작 혹은 그룹으로 모인 소비자들의 주문에 따라 해당 소비자의 의견을 일부 반영해서 생산하는 것을 의미합니다.')}`,
        ],
        message: t('주문 제작 안내가 추가되었어요'),
        name: t('주문제작'),
    };
    //? 2차결제
    const secondPayProps = {
        descriptions: [
            `■ ${t('2차 결제')}\n\n`,
            `■ ${t('추후 2차 결제가 있습니다. 폰디에 인증한 이메일/문자로 결제 기간 및 금액 안내가 발송되며 기간 내 미결제는 구매자님 과실로 불이익이 발생할 수 있습니다.')}\n`,
            `${t('2차 미결제된 작품은 일정 보관 기간을 거친 후 구매자의 폐기처분 동의로 간주하여 전량 폐기됩니다. 반드시 기간 내 결제를 부탁드립니다.')}`,
        ],
        message: t('2차 결제 안내가 추가되었어요'),
        name: t('2차 결제'),
    };
    //? 개봉영상
    const unboxingProps = {
        descriptions: [
            `■ ${t('개봉 영상 촬영 방법')}\n`,
            ` • ${t('개봉 영상은 포장을 뜯기 전부터 끊기지 않게 원테이크로(one take)로 촬영해야 합니다.')}\n`,
            ` • ${t('송장번호가 잘 보이게 촬영 시작합니다.')}\n`,
            ` • ${t('택배 상자 6면이 화면 밖을 벗어나지 않고 [미개봉 상태]임을 촬영합니다.')}\n`,
            ` • ${t('내용물이 상하지 않도록 조심히 개봉합니다.')}\n`,
            ` • ${t('내용물을 모두 꺼내고 빈 상자를 촬영하여 구성품이 모두 도착했는지 확인합니다.')}\n`,
            ` • ${t('내용물을 확인합니다. 불량이 발견되면 개봉 영상에서 불량을 확인할 수 있도록 3초 이상 보여줍니다.')}\n`,
            ` • ${t('모두 촬영했다면 개봉 영상을 종료하고 저장합니다.')}`,
        ],
        message: t('개봉영상 안내가 추가되었어요'),
        name: t('개봉영상'),
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-bg", css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '8px',
            padding: '10px 12px',
            borderRadius: '8px',
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '2px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 gray-80" }, { children: t('안전하게 판매하기') })), (0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/point_down_finger.svg`, css: { width: '20px', height: '20px' } })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px',
                } }, { children: [(0, jsx_runtime_1.jsx)(_1.RefundEditorTemplateTooltip, { propsData: basicProps, comment: arrayToString(basicProps.descriptions) }), (0, jsx_runtime_1.jsx)(_1.RefundEditorTemplateTooltip, { propsData: customProps, comment: arrayToString(customProps.descriptions) }), (0, jsx_runtime_1.jsx)(_1.RefundEditorTemplateTooltip, { propsData: secondPayProps, comment: arrayToString(secondPayProps.descriptions) }), (0, jsx_runtime_1.jsx)(_1.RefundEditorTemplateTooltip, { propsData: unboxingProps, comment: arrayToString(unboxingProps.descriptions) })] }))] })));
}
exports.default = default_1;
